import { LoginRequestData, PasswordRequestData, PostalCode, User, UserEditRequestData } from './AuthRequest.interface';
import api from '@/services/Api';

export const AuthRequest = {
	crsf: () => {
		return api.get('api/csrf-cookie');
	},

	login: (authData: LoginRequestData) => {
		return api.post<ApiResponse<User, any>>('api/auth/login', authData);
	},

	logout: () => {
		return api.post('/api/auth/logout');
	},

	getMe: () => {
		return api.get<ApiResponse<User, any>>('/api/user/me');
	},

	updateProfile: (userData: UserEditRequestData) => {
		return api.post<ApiResponse<User, any>>('/api/user/me', userData);
	},

	changePassword: (userData: PasswordRequestData) => {
		return api.put<ApiResponse<User, any>>('/api/user/me', userData);
	},

	resetPassword: (data: { email: string }) => {
		return api.post('api/user/reset-password', data);
	},

	resetPasswordConfirm: (data: {password_new: string; password_new_confirmation: string; reset_code: string}) => {
		return api.post('api/user/reset-password', data);
	},

	checkInvite: (data: { invite_code: string }) => {
		return api.post('api/user/check-invite', data);
	},

	register: (data: any) => {
		return api.post('api/user/register', data);
	},

	activateUser: (data: {activation_code: string; password: string; password_confirmation: string}) => {
		return api.post('api/user/activate', data);
	},
	
	getCity: (postal_code: string) => {
		return api.post<ApiResponse<PostalCode>>('api/get-city', { postal_code });
	},
};
